
import {Component, Prop, Vue} from "vue-property-decorator";
import {changeUserAccount} from "@/api/users";
import {ElForm} from "element-ui/types/form";

@Component({
  name: "AccountTypeForm",
})
export default class extends Vue {

  @Prop(Array) readonly options: [];


  private showEditAccountType = false;

  private form = {
    accountType: ''
  };
  private rules = {
    accountType: [
      {required: true, message: "请选择帐套类型", trigger: "blur"}
    ]
  }
  private selectedUserIds = [];


  public handleEditAccountType(row) {
    this.selectedUserIds = [row.id]
    this.showEditAccountType = true;
  }

  public cancelEditAccountType() {
    (this.$refs['form'] as ElForm).resetFields();
    this.showEditAccountType = false;
  }

  public confirmEditAccountType() {
    (this.$refs['form'] as ElForm).validate(valid => {
      if (!valid) {
        return false
      }

      const obj = {
        accountType: this.form.accountType,
        userIds: this.selectedUserIds
      };
      changeUserAccount(obj)
          .then(() => {
            this.$message.success("操作成功");
            this.$emit("confirm")
          })
          .finally(() => {
            this.showEditAccountType = false;
            (this.$refs['form'] as ElForm).resetFields();
          })
    })
  }
}
